import React from "react";
import Icon from "../../../components/icon/icon";
import { Brand } from "../../../types";

export interface ProductFiltersProps {
  brands: Brand[];
  selectedBrandId: string;
  searchTerm: string;
  selectedStatus: string;
  onBrandChange: (brandId: string) => void;
  onSearchChange: (searchTerm: string) => void;
  onStatusChange: (status: string) => void;
  onClearFilters: () => void;
  isLoading?: boolean;
  disabledBrandFilter?: boolean;
}

export const ProductFilters: React.FC<ProductFiltersProps> = ({
  brands,
  selectedBrandId,
  searchTerm,
  selectedStatus,
  onBrandChange,
  onSearchChange,
  onStatusChange,
  isLoading = false,
  disabledBrandFilter = false,
}) => {
  return (
    <div className="product-filters">
      <div className="product-filters__content">
        <div className="product-filters__group">
          <select
            value={selectedBrandId}
            onChange={(e) => onBrandChange(e.target.value)}
            className="product-filters__select"
            disabled={isLoading || disabledBrandFilter}
          >
            <option value="">Все бренды</option>
            {brands.map((brand) => (
              <option key={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>

        <div className="product-filters__group">
          <select
            value={selectedStatus}
            onChange={(e) => onStatusChange(e.target.value)}
            className="product-filters__select"
            disabled={isLoading}
          >
            <option value="">Все статусы</option>
            <option value="ACTIVE">Активен</option>
            <option value="RENTING">В аренде</option>
            <option value="ARCHIVED">Архивный</option>
          </select>
        </div>

        <div className="product-filters__group">
          <div className="product-filters__search">
            <Icon
              name="search"
              size="small"
              className="product-filters__search-icon"
            />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Поиск по номеру лота (например: 123)..."
              className="product-filters__input"
              disabled={isLoading}
            />
            {searchTerm && (
              <button
                onClick={() => onSearchChange("")}
                className="product-filters__clear-search"
                disabled={isLoading}
              >
                <Icon name="delete" size="small" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
